import {ACTION_CODE} from './_actionCode';
import {VehicleTypeService} from '../../services';
import {ErrorModel, ResultModel} from '../../models';
import {LoggerService} from '../../services';
const FUNCTION_CODE = 'DELETE_VEHICLETYPE';

export async function deleteVehicleType(userData: Record<string, any>, vehicleTypeId: number) {
    try {
        LoggerService.logInfo('Action - deleteVehicleTypeById - Start');

        const deleteVehicleTypeByIdResult = await VehicleTypeService.deleteVehicleType(userData, vehicleTypeId);

        LoggerService.logInfo('Action - deleteVehicleTypeById - End - Success');

        return ResultModel.newSuccessResult(deleteVehicleTypeByIdResult);
    }
    catch (error: any) {
        LoggerService.logInfo('Action - deleteVehicleTypeById - End - Error');

        const newErr = ErrorModel.newError({
            code: `${ACTION_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue lors de la suppression d\'une banque',
            error: error
        });
        LoggerService.logError(error);

        return ResultModel.newErrorResult(newErr);
    }
}
